<template>
  <div class="applycert">
    <div class="apply-title">
      <img src="@/assets/tip.png" />
      <span>由版权家为你自行上传的作品进行的版权存证，版权家不对您上传内容的真实性作验证。</span>
    </div>
    <div class="certList_u_count">
        <div class="certList_upload">
            <div class="certList_left">
                添加存证附件：
            </div>
            <div class="certList_right">
                <div class="certList_right_top">
                    <MyUploadHw :oldShowList="showList" :maxNumber="maxNumber" :fileMultiue="true" @listentochildevent="showmessagefromchild" />
                    <div class="showtextDf">
                        <div>温馨提示：</div>
                        <p>1、同一批的存证文件归属于同一标签，不支持重置；</p>
                        <p>2、支持文件批量上传，一次不能超过10个文件；</p>
                        <p>3、不同类型上传文件大小不同，分别如下: 文档类：20M，图片类：100M，音视频类：500M，其他：200M；</p>
                        <p>4、文件永久保全。</p>
                    </div>
                </div>
                <div style="display:flex;flex-wrap: wrap;">
                    <div v-for="(item,index) in showList" :key="index" class="show_Picture">
                        <div class="showSc">
                            <!-- <div v-if="item.ifcz=='N'" class="showCm">文件已被存证</div> -->
                            <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" />
                            <span class="showDelete">
                                <img @click.stop="deleteList(item)" class="showshanchu" src="./images/shanchu.png" />
                            </span>
                            
                        </div>
                        <div>{{item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="certList_name">
            <div style="font-size: 16px;font-weight: 400;color: #333;">存证名称：</div>
            <input maxlength="20" v-model="name" type="text" placeholder="请填写存证名称" />
        </div>
    </div>
    <div class="certList_w_count">
        <div class="cw_bz_type">存证保障：</div>
        <div class="cw_ul_type">
            <div class="cw_li_tb">
                <img style="width:32px;height:32px;" src="./images/applycert1.png" />
                <div>可信时间认证</div>
                <p>国家授时中心拥有国内第一、世界第四规模的守时原子钟组，负责确定和保持的我国的原子时标准（TA(NTSC)）和协调世界时标准（UTC(NTSC)），国家标准时间与国际协调世界时UTC的偏差数值保持在10ns以内</p>
            </div>
            <div class="cw_li_tb">
                <img style="width:37px;height:34px;" src="./images/applycert2.png" />
                <div>区块链存证</div>
                <p>只需花费三分钟即可免费办理的区块链存证证书，能够快速有效地固定作品信息。作品信息将被上传到区块链，获得精准授时，信息永久不可篡改。版权所有者日后进行版权授权交易及维权时，区块链存证证书都将成为有效的证据。</p>
            </div>
            <div class="cw_li_tb">
                <img style="width:37px;height:31px;" src="./images/applycert3.png" />
                <div>电子签名认证</div>
                <p>电子签名认证可为数字版权存证提供可信签名，提交至北京互联网法院时有较高的公信力</p>
            </div>
        </div>
        
    </div>
    <div v-show="userInfo && userInfo!='' && flagId=='' " class="certList_w_count_wrap certList_w_count" style="padding-bottom: 40px;height:auto;">
        <div style="line-height: 42px;" class="cw_bz_type">支付方式：</div>
        <div class="cw_ul_type">
            <component :is="PayWay" @onselected="handlePayWaySelect" type="01" :code="codeType"></component>
        </div>
    </div>
    <div style="text-align:center;width:1334px;margin:0 auto;height:102px;line-height:42px;">
        <input class="certbutton" id="addcertButton" @click="addcert" type="button" value="存证" />
    </div>
    <!--    加油包    -->
    <monitorBag bizType="01" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
    <!--    会员续费    -->
    <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
  </div>
</template>

<script>
import $ from 'jquery';
import MyUploadHw from '@/views/main-components/my-upload-hw';
import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
import PayWay from '@/views/main-components/pay-way';
import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay';
import {getOrderWorksDulicate,getOrderJudicialDeposit,postResubmit} from '@/api/staticPage';
import Cookies from "js-cookie";
import util from "../../../libs/util";
const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
export default {
    metaInfo: {
        title: '版权存证|时尚知识产权保护平台',
        meta: [{                 // set meta
            name: 'keyWords',
            content: ''
        },{
            name: 'Description',
            content: ''
        }]
    },
    name: "applyCert",
    components:{
        MyUploadHw,
        monitorBag,
        myczPay,
        PayWay
    },
    data(){
        return{
            total:10,
            pages:10,
            model1: '',
            showList:[],
            name:'',
            urlMd5s:'',
            urlNames:'',
            urls:'',
            music:require('@/assets/music_icon2.png'),
            text:require('@/assets/text_icon2.png'),
            video:require('@/assets/video_icon2.png'),
            other:require('@/assets/file_icon2.png'),
            monitorBagState: false, //加油包
            myczPayState:false,
            maxNumber:10,
            userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
            flagId:'', //存证ID
            PayWay:'',
            payWay: '',
            codeType:null,
            isPreRechargeFlag:null
        }
    },
    watch:{
    	"$store.state.app.showPayWay":function(){
    		if(this.$store.state.app.showPayWay){
    			this.userInfo = JSON.parse(Cookies.get("userInfo")),
    			this.flagId = '',
    			this.PayWay = 'PayWay'
    		}
    	}
    },
    created(){
        this.codeType = this.$route.query.code;
        if(this.$route.query.id){
            let id = this.$route.query.id
            this.flagId = id;
            this.getRequest("/orderCommon/get/" + id).then(res => {
                if(res.code == 200){
                    let tempshowList = res.result.attachments
                    for(let i=0;i<tempshowList.length;i++){
                        let layout = tempshowList[i].attachmentUrl.substring(tempshowList[i].attachmentUrl.lastIndexOf('.')+1)
                        if(reImg.test(layout)){
                            // tempshowList[i].url = tempshowList[i].attachmentUrl
                            tempshowList[i].url = util.thumbnail(tempshowList[i].attachmentUrl);
                        }else if(reMusic.test(layout)){
                            tempshowList[i].url = this.music;
                        }else if(reText.test(layout)){
                            tempshowList[i].url = this.text;
                        }else if(reVideo.test(layout)){
                            tempshowList[i].url = this.video;
                        }else{
                            tempshowList[i].url = this.other;
                        }
                        tempshowList[i].name = tempshowList[i].attachmentName
                        
                    }
                    // for(let i=0;i<tempshowList.length;i++){
                    //     tempshowList[i].url = tempshowList[i].attachmentUrl
                    //     tempshowList[i].name = tempshowList[i].attachmentName
                    // }
                    this.showList = tempshowList
                    this.name = res.result.orderTitle
                }
            })
        }
        this.isLogin = Cookies.get("userInfo")? true : false;
        this.$store.state.app.showPayWay =Cookies.get("userInfo") && Cookies.get("userInfo") != ''? true : false
        this.PayWay = this.$store.state.app.showPayWay? 'PayWay':''
    },
    methods: {
        handlePayWaySelect(e) {
            console.log(e);

            this.payWay = e;
            if(e == null){
                this.isPreRechargeFlag = 0
            }else{
                if(e.activityName == "预存权益支付"){
                    this.isPreRechargeFlag = 1
                }else{
                    this.isPreRechargeFlag = 0
                }
            }
        },
        selectType(val){
            console.log(val)
        },
         //加油包
        monitorBagFuc() {
            this.monitorBagState = false;
        },
        myczPayFuc() {
            console.log('会员续费弹框');
            this.myczPayState = false;
        },
        handleImageLoaded(item){
            // let tempToUrl = item.url + "?x-image-process=image/resize,m_fixed,w_84,h_60"
            $(this).attr('src',item.url)
        },
        showmessagefromchild(data){
            let _this = this;
            console.log('+++++++++++++++++++++++++++++++++++',data)
            for(let i = 0;i < data.length;i++){
                // this._getOrderWorksDulicate(data[i].md5Hash).then((res)=>{
                //     if(res){
                //         data[i].ifcz = 'Y'
                //     }else{
                //         data[i].ifcz = 'N'
                //     }
                // })
                let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.')+1)
                if(reImg.test(layout)){
                    // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                    //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                    // }
                    data[i].url = util.thumbnail(data[i].url);
                }else if(reMusic.test(layout)){
                    data[i].url = _this.music;
                }else if(reText.test(layout)){
                    data[i].url = _this.text;
                }else if(reVideo.test(layout)){
                    data[i].url = _this.video;
                }else{
                    data[i].url = _this.other;
                }
            }
            console.log('获取接口后的存证数据',data)
            _this.showList = data
        },
        addcert(){
             $("#addcertButton").attr("disabled","disabled");
            let _this = this;
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            let chanShowList = _this.showList
            _this.urlMd5s='';
            _this.urlNames='';
            _this.urls='';
            if(userInfo.length == 0){
                toast('请登录后再操作',function(){
                    _this.$router.push({
                        path:'/'
                    })
                })
                return false;
            }
            // if(userInfo.realNameStatus != 'complete_real_name'){
            //     toast('请实名认证后使用功能',function(){
            //         _this.$router.push({
            //             path:'/authentication'
            //         })
            //     })
            //     return false;
            // }
            for(let i=0;i<chanShowList.length;i++){
                _this.urls += i==chanShowList.length-1?chanShowList[i].attachmentUrl:chanShowList[i].attachmentUrl+',';
                _this.urlMd5s += i==chanShowList.length-1?chanShowList[i].md5Hash:chanShowList[i].md5Hash + ',';
                _this.urlNames += i==chanShowList.length-1?(chanShowList[i].name ? chanShowList[i].name.split('.')?chanShowList[i].name.split('.')[0]:chanShowList[i].name:''):(chanShowList[i].name ? chanShowList[i].name.split('.')?chanShowList[i].name.split('.')[0]:chanShowList[i].name:'')+','
            }
            if(_this.urls==''){
                toast('请选择要上传的存证附件')
                $("#addcertButton").removeAttr("disabled");  
                return false;
            }   
            if(_this.name==''){
                toast('请输入存证名称')
                $("#addcertButton").removeAttr("disabled");  
                return false;
            }
            if(this.$route.query.id){ 
                let params = {
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    name:_this.name,
                    urlMd5s:_this.urlMd5s,
                    urlNames:_this.urlNames,
                    urls:_this.urls,
                    orderCommonId:this.$route.query.id,
                    preRechargeFlag:_this.isPreRechargeFlag
                }
                postResubmit(params).then((res)=>{
                    console.log('提交成功后的回调',res)
                    if(res.code==200){
                        toast('存证保存成功')
                        this.$router.push({ path:'/myExisting' })
                    }else{
                        toast(res.message)
                        $("#addcertButton").removeAttr("disabled");   
                    }
                })
            }else{
                let params = {
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    name:_this.name,
                    urlMd5s:_this.urlMd5s,
                    urlNames:_this.urlNames,
                    urls:_this.urls,
                    preRechargeFlag:_this.isPreRechargeFlag
                }
                getOrderJudicialDeposit(params).then((res)=>{
                    console.log('提交成功后的回调',res)
                    if(res.code==200){
                        toast('存证保存成功')
                        this.$router.push({ path:'/myExisting' })
                    }else if(res.code==213){
                        toast("请实名认证后使用功能")
                        this.$router.push('/authentication')                        
                    }else if(res.code==214){
                        toast("请购买产品后使用")
                        if(userInfo.accountType=="person" ){
                            this.$router.push('/goods')
                        }else{
                            this.$router.push('/goods')
                        }
                    }else if(res.code==216){
                        this.monitorBagState = true;
                         $("#addcertButton").removeAttr("disabled");  
                    }else if(res.code==215){
                        toast("请购买产品后使用")
                        this.myczPayState = true;
                         $("#addcertButton").removeAttr("disabled");  
                    }else{
                        toast(res.message)
                         $("#addcertButton").removeAttr("disabled");  
                    }
                })
            }
        },
        _getOrderWorksDulicate(attachmentMd5){
            let _this = this;
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            let params = {
                attachmentMd5:attachmentMd5,
                registerId:userInfo && userInfo.id?userInfo.id:'',
            }
            let mideData = getOrderWorksDulicate(params).then((res)=>{
                var jsonObj = ''
                var obj = res.result
                if(jsonObj == 0){
                    return true;
                }else{
                    return false;
                }
            })
            return mideData
        },
        deleteList(item){
            console.log('获取的临时文件的',item)
            let totalArray = this.showList
            for(let i = 0; i < totalArray.length; i++){
                if(totalArray[i].attachmentUrl == item.attachmentUrl){
                    this.showList.splice(i,1)
                }
            }
        }
    },
};
</script>

<style scoped lang="less">
    .show_Picture{
        margin-right:20px;
        margin-bottom: 20px;
        div{
            width:103px;
            height:17px;
            font-size:12px;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:17px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            margin-top:5px;
        }
        .showSc{
            position:relative;
            height:70px;
            width: 103px;
            cursor:pointer;
            &:hover{
                width:103px;
                height:70px; 
                .showDelete{
                    display:block;
                }
            }
            .showDelete{
                width:103px;
                height:70px;
                background: rgba(0,0,0,0.3);
                display:none;
                position:absolute;
                left:0;
                right:0;
                top:0;
                bottom:0;
                margin:auto;              
                /*border-radius:none;*/
                text-align: center;
                overflow: hidden;
            }
            .showshanchu{
                width:18px;
                height:18px;
                margin-top:26px;
            }
            .showCm{
                width:84px;
                height:25px;
                background:rgba(0,0,0,1);
                border-radius:6px 6px 0px 0px;
                opacity:0.6;
                font-size:12px;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:25px;
                text-align:center;
                position:absolute;
                left:0;
                top:0;
            }
        }
    }
    .applycert{
        width:1334px;
        margin: 0 auto;
        .apply-title{
            height:60px;
            line-height:60px;
            img{
                height: 17px;
                width:17px;
                vertical-align: middle;
            }
            span{
                font-size:14px;
                color:rgba(161,163,165,1);
                vertical-align: middle;
                margin-left: 8px;
            }
        }
    }
    .certList_u_count{
        width:1334px;
        min-height:440px;
        margin:0 auto;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
        .certList_name{
            display:flex;
            justify-content: flex-start;
            height:116px;
            line-height:116px;
            align-items: center;
            div{
                margin-left:40px;
                margin-right:42px;
                width:80px;
            }
            input{
                width:383px;
                height:40px;
                line-height: 40px;
                background:rgba(255,255,255,1);
                border-radius:4px;
                border:1px solid rgba(236,236,236,1);
                text-indent: 10px;
            }
            input:active,input:focus,input:hover{
                border:1px solid #121210;
                outline: none;
            }
        }
    }
    .certList_upload{
        width:1334px;
        min-height:323px;
        display:flex;
        justify-content: flex-start;
        border-bottom:1px solid rgba(238,238,238,1);
        .certList_left{
            margin:30px 20px 0px 30px;
            width:112px;
            height:22px;
            font-size:16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:22px;
        }
        .certList_right{
            display:flex;
            flex-direction: column;
            .certList_right_top{
                height:194px;
                display:flex;
                justify-content: flex-start;
                .showtextDf{
                    margin-left:20px;
                    div{
                        height:20px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:20px;
                        margin-top:64px;
                        margin-bottom:10px;
                    }
                    p{
                        font-size:14px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:20px;
                    }
                }
            }
        }
    }
    .certList_w_count{
        width:1334px;
        height:324px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
        margin:0 auto;
        margin-top:20px;
        display:flex;
        justify-content: flex-start;
        // .certList_w_count_wrap {
        //     display:flex;
        //     justify-content: flex-start;
        // }
        .cw_bz_type{
            width:80px;
            height:22px;
            font-size:16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:22px;
            margin:30px 42px 0px 30px;
        }
        .cw_ul_type{
            display:flex;
            justify-content: flex-start;
            margin-top:30px;
            .cw_li_tb{
                margin-right: 20px;
                width: 212px;
                height: 264px;
                background: #ffffff;
                border-radius: 4px;
                border: 1px solid #b9b9b9;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                img{
                    margin:20px 0px 20px 20px;
                }
                div{
                    height:20px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:20px;
                    margin-bottom:10px;
                    margin-left:20px;
                }
                p{
                    width:172px;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:17px;
                    margin:0 auto;
                }
            }
        }
    }
    .certbutton{
        width:124px;
        height:42px;
        background:rgba(18,18,16,1);
        line-height:42px;
        font-size:14px;
        font-weight:600;
        color:#fff;
        cursor: pointer;
        border:none;
        outline:none;
        margin:30px 0;
    }
    input::-webkit-input-placeholder { /* Chrome/Opera/Safari */ 
        font-size:14px;
        font-weight:400;
        color:rgba(153,153,153,1);
    }
    input::-moz-placeholder { /* Firefox 19+ */  
        font-size:14px;
        font-weight:400;
        color:rgba(153,153,153,1);
    }
    input:-ms-input-placeholder { /* IE 10+ */ 
        font-size:14px;
        font-weight:400;
        color:rgba(153,153,153,1);
    }
    input:-moz-placeholder { /* Firefox 18- */ 
        font-size:14px;
        font-weight:400;
        color:rgba(153,153,153,1);
    }
</style>

